// 權限類型
export const PermissionTypes = {
  QUERY: 'Query',
  ADD: 'AddNew',
  EDIT: 'Edit',
  DELETE: 'Del',
  EXPORT: 'Export',
  PRINT: 'Printer',
  APPROVE: 'Approve',
} as const;

// 權限動作對應
export const PermissionActions = {
  VIEW: 'query',
  CREATE: 'add',
  UPDATE: 'edit',
  DELETE: 'delete',
  EXPORT: 'export',
  PRINT: 'print',
  APPROVE: 'approve',
} as const;

// 模組代碼
export const Modules = {
  // 系統管理
  USER: 'SYS_USER_MGMT',
  PERMISSION: 'SYS_PERMISSION',
  ORGANIZATION: 'SYS_DEPT_MGMT',
  
  // 業務模組
  INVENTORY: 'INV_MAIN',
  CUSTOMER: 'CUS_MAIN',
  PRODUCT: 'PRODUCT',
  PRODUCT_MASTER: 'pw1113f1',  // 產品資料建檔
  ORDER: 'ORDER',
  SALES: 'SALES_MAIN',
  SALES_CONTRACT: 'pwc202f1',  // SC 銷售合約建檔
  SALES_RETURN: 'pwc205f1',  // C205 銷貨退回單
  J201: 'pwj201f1',  // 樣品申請單
  J202: 'pwj202f1',  // 樣品繳庫單
  J203: 'pwj203f1',  // 樣品交運單
  EXCHANGE_RATE: 'fin_exchangerate',  // 匯率基本檔
  FIN_BILLDATA: 'fin_billdata',  // 票據/支票管理
  PW9213: 'pw9213f1',  // 員工年度考勤記錄
  PW9119: 'pw9119f1',  // 感應卡保管建檔
  PW9205: 'pw9205f1',  // 職務代理人異動單
  PW9224: 'pw9224f1',  // 出差單
  PW9233: 'pw9233f1',  // 非固定薪資輸入
  PW9201: 'pw9201f1',  // 人員增補申請單
  P922A: 'pw922af1',   // 請假單
  P9207: 'pw9207f1',   // 離職申請單
  P9209: 'pw9209f1',   // 留職停薪申請單
  PW933A: 'pw933af1',  // 部門薪資總表
  PW9334: 'pw9334f1',  // 薪資異動記錄明細
  PW9335: 'pw9335f1',  // 個人薪資單
  PW9336: 'pw9336f1',  // 薪資印領清冊
  PW9337: 'pw9337f1',  // 個人獎金明細表
  PW9339: 'pw9339f1',  // 薪資明細表
  PW933B: 'pw933bf1',  // 薪資撥款清冊
  PW9341: 'pw9341f1',  // 個人年度薪資異動
  PWD210: 'pwd210f1',  // 驗布指示單（入庫單）
  PWD216: 'pwd216f1',  // 入庫單異常說明-採
  PWD217: 'pwd217f1',  // 入庫單異常說明-主管
  D206: 'pwd206f1',    // 繳庫退出單
  PWD203: 'pwd203f1',  // 受訂託工單
  PWD211: 'pwd211f1',  // 計劃採購單
  PWD212: 'pwd212f1',  // 計劃託工單
  PWD204: 'pwd204f1',  // 託工入庫單
  PWD310: 'pwd310f1',  // 廠商對帳單
  PW9614: 'pw9614f1',  // 請假月結作業
  PW9531: 'pw9531f1',  // 薪資計算
  P2201: 'pw2201f1',   // 採購入庫單
  PW2202: 'pw2202f1',  // 採購退回單
  PW2501: 'pw2501f1',  // 採購入庫單-核准
  PW9403: 'pw9403f1',  // 員工資料查詢-部門
  PW9404: 'pw9404f1',  // 員工資料查詢-總經理
  PW930B: 'pw930bf1',  // 部門人事統計表
  PW9321: 'pw9321f1',  // 請假明細表
  PW9304: 'pw9304f1',  // 人事通知單印表
  PW9306: 'pw9306f1',  // 部門編制明細表
  PW9310: 'pw9310f1',  // 個人日出勤明細表
  PW9315: 'pw9315f1',  // 部門個人出勤時間
  PW9312: 'pw9312f1',  // 部門-日出勤異常表
  PW9314: 'pw9314f1',  // 月份請假總表
  PW9318: 'pw9318f1',  // 感應卡-每筆出勤明細
  PW9319: 'pw9319f1',  // 感應卡-保管清冊
  PW150K: 'pw150kf1',  // 廠商資格核准-總經理
  PWG332: 'pwg332f1',  // 交運單繳款明細表
  PW150H: 'pw150hf1',  // 廠商資格核准-部門
  PW1315: 'pw1315f1',  // 包裝方式清冊
  PW1313: 'pw1313f1',  // 產品清冊
  PW1312: 'pw1312f1',  // 工繳清冊
  PW98M2: 'pw98m2f1',  // 人事資料核准沖銷-門戶選單
  PWJ324: 'pwj324f1',  // 專輯預估成本明細
  PWJ308: 'pwj308f1',  // 研發廠商對帳單
  PWC301: 'pwc301f1',  // S/C明細表
  PWG302: 'pwg302f1',  // 應收帳款明細/統計
  PWG304: 'pwg304f1',  // 預收帳款明細表
  PW9322: 'pw9322f1',  // 請假明細表（部門用）
  PW9324: 'pw9324f1',  // 年度請假總表
  PWD307: 'pwd307f1',  // 廠商年度採購數量
  PWD308: 'pwd308f1',  // 廠商年度託工數量
  PWJ30A: 'pwj30af1',  // 小嘜頭列印
  PWJ30B: 'pwj30bf1',  // 標簽貼紙列印
  PW98M5: 'pw98m5f1',  // 人事資料核准沖銷
  PWC512: 'pwc512f1',  // 計畫生產通知單核准
  PWD503: 'pwd503f1',  // 計劃/受訂託工單核准
  PWR5C4: 'pwr5c4f1',  // 交運單沖銷核准
  PWC505: 'pwc505f1',  // 銷貨退回單核准
  PWD504: 'pwd504f1',  // 託工入庫單核准
  PWD514: 'pwd514f1',  // 異常託工入庫單核准
  PWD5N2: 'pwd5n2f1',  // 異常繳庫單核准沖銷
  PWD5N4: 'pwd5n4f1',  // 異常託工入庫單核准沖銷
  PWD5M6: 'pwd5m6f1',  // 繳庫退出單核准沖銷
  PWH5M8: 'pwh5m8f1',  // 請款單核准沖銷
  PWG5M5: 'pwg5m5f1',  // 應收帳款調整單沖銷
  PWG5M1: 'pwg5m1f1',  // 繳款單核准沖銷
  T207: 'pwt207f1',    // 廠商會議記錄
  T20A: 'pwt20af1',    // 客戶會議記錄
  G203: 'pwg203f1',    // 應收帳款回覆作業
  G204: 'pwg204f1',    // 銷貨折讓單
  C209: 'pwc209f1',    // 新布種開發申請單
  C212: 'pwc212f1',    // 胚布預估單
  J209: 'pwj209f1',    // 研發庫存繳庫單
  J218: 'pwj218f1',    // 新產品開發分析
  PWG504: 'pwg504f1',  // 銷貨折讓單核准
  PWG501: 'pwg501f1',  // 繳款單核准
  PWD512: 'pwd512f1',  // 異常繳庫單核准
  PWR5J3: 'pwr5j3f1',  // 樣品交運單核准沖銷
  PWL304: 'pwl304f1',  // 發行文件一覽表
  PWJ5M7: 'pwj5m7f1',  // 研發領用單核准沖銷
  PWJ508: 'pwj508f1',  // 研發繳庫單核准
  PWJ503: 'pwj503f1',  // 樣品交運單核准
  PWN511: 'pwn511f1',  // 客訴單-採購組長核准
  PWN5MA: 'pwn5maf1',  // 客訴單-業務經辦核准沖銷
  PWN5N1: 'pwn5n1f1',  // 客訴單-採購組長核准沖銷
  PWN5MB: 'pwn5mbf1',  // 客訴單-採購經辦核准沖銷
  L204: 'pwl204f1',    // ISO文件內頁建檔
  L205: 'pwl205f1',    // ISO稽核查檢表
  L316: 'pwl316f1',    // 稽核改善進度管制
  M302: 'pwm302f1',    // 庫位庫存量表
  M309: 'pwm309f1',    // 板號庫位批號庫存
  N301: 'pwn301f1',    // 客訴原因明細表
  N211: 'pwn211f1',    // 客訴工廠買收交運單
  D202: 'pwd202f1',    // 繳庫單
  D301: 'pwd301f1',    // 採購單明細表
  C358: 'pwc358fa',    // S/C受訂統計排行表
  D324: 'pwd324f1',    // 領用單明細表
  H302: 'pwh302f1',    // 應付帳款明細表
  C324: 'pwc324f1',    // 交運對帳單
  D302: 'pwd302f1',    // 繳庫單明細表
  D312: 'pwd312f1',    // 繳庫進出明細表
  D303: 'pwd303f1',    // 託工單明細表-廠商
  D304: 'pwd304f1',    // 託工入庫單明細表
  D305: 'pwd305f1',    // 採購單統計表
  C305: 'pwc305f1',    // 交運統計表
  D306: 'pwd306f1',    // 託工單統計表
  D309: 'pwd309f1',    // 採購預計交期明細
  D313: 'pwd313f1',    // 入布明細表
  D320: 'pwd320f1',    // 廠商工繳比較表
  D328: 'pwd328f1',    // 異常入庫單說明明細表
  P131K: 'pw131kf1',   // 員工簡碼清冊
  C304: 'pwc304f1',    // 交運明細表
  PWC315: 'pwc315f1',  // 交運單總表
  P1304: 'pw1304f1',   // 公司資料列印
  G305: 'pwg305f1',    // 繳款單明細表
  D314: 'pwd314f1',    // 產品進貨成本表
  G303: 'pwg303f1',    // 應收帳款月份統計
  G306: 'pwg306f1',    // 應收/付佣金餘額表
  G319: 'pwg319f1',    // 交運開票繳款明細
  H301: 'pwh301f1',    // 應付未付款項明細
  H303: 'pwh303f1',    // 應付帳款沖帳明細
  J310: 'pwj310f1',    // 原料代號與工廠布號對照表
  P303: 'pwp303f1',    // 物化性報告明細表
  P9301: 'pw9301f1',       // 員工資料表列印查詢
  P930H: 'pw930hf1',       // 公司行事日曆
  CLOCK_INOUT: 'pw9220f1', // 簽到/退作業
  PW9701: 'pw9701f1',      // 人事各類單據-導覽選單
  PW9208: 'pw9208f1',      // 資遣通知單
  P251: 'pwp251f1',        // 內外銷PACKING LIST
  PWP255: 'pwp255f1',      // PACKING LIST 客戶資料（貨櫃）
  PWP254: 'pwp254f1',      // 出貨包裝單 (Packing List)
  PWH201: 'pwh201f1',   // 請款單
  PWH508: 'pwh508f1',   // 請款單核准-主管
  AUDIT_LOG: 'sys_auditlog', // 稽核記錄查詢（僅管理者群組）
  FINANCE: 'FINANCE',
  HR: 'HR',
  
  // 其他
  REPORT: 'REPORT',
  SYSTEM: 'SYSTEM',
} as const;

// 預定義權限組合
export const Permissions = {
  // 使用者管理
  USER_VIEW: `${Modules.USER}_QUERY`,
  USER_CREATE: `${Modules.USER}_ADD`,
  USER_UPDATE: `${Modules.USER}_EDIT`,
  USER_DELETE: `${Modules.USER}_DELETE`,
  
  // 權限管理
  PERMISSION_VIEW: `${Modules.PERMISSION}_QUERY`,
  PERMISSION_CREATE: `${Modules.PERMISSION}_ADD`,
  PERMISSION_UPDATE: `${Modules.PERMISSION}_EDIT`,
  PERMISSION_DELETE: `${Modules.PERMISSION}_DELETE`,
  PERMISSION_USER_UPDATE: `${Modules.PERMISSION}_USER_UPDATE`,
  
  // 庫存管理
  INVENTORY_VIEW: `${Modules.INVENTORY}_QUERY`,
  INVENTORY_CREATE: `${Modules.INVENTORY}_ADD`,
  INVENTORY_UPDATE: `${Modules.INVENTORY}_EDIT`,
  INVENTORY_DELETE: `${Modules.INVENTORY}_DELETE`,
  INVENTORY_EXPORT: `${Modules.INVENTORY}_EXPORT`,
  INVENTORY_PRINT: `${Modules.INVENTORY}_PRINT`,
  
  // 客戶管理
  CUSTOMER_VIEW: `${Modules.CUSTOMER}_QUERY`,
  CUSTOMER_CREATE: `${Modules.CUSTOMER}_ADD`,
  CUSTOMER_UPDATE: `${Modules.CUSTOMER}_EDIT`,
  CUSTOMER_DELETE: `${Modules.CUSTOMER}_DELETE`,
  CUSTOMER_EXPORT: `${Modules.CUSTOMER}_EXPORT`,
  
  // 銷售合約 (SC)
  SC_VIEW: `${Modules.SALES_CONTRACT}_QUERY`,
  SC_CREATE: `${Modules.SALES_CONTRACT}_ADD`,
  SC_UPDATE: `${Modules.SALES_CONTRACT}_EDIT`,
  SC_DELETE: `${Modules.SALES_CONTRACT}_DELETE`,
  SC_EXPORT: `${Modules.SALES_CONTRACT}_EXPORT`,
  SC_PRINT: `${Modules.SALES_CONTRACT}_PRINT`,
  SC_APPROVE: `${Modules.SALES_CONTRACT}_APPROVE`,

  // 管理員
  ADMIN: 'ADMIN',
} as const;

// 權限類型定義
export type PermissionType = typeof PermissionTypes[keyof typeof PermissionTypes];
export type PermissionAction = typeof PermissionActions[keyof typeof PermissionActions];
export type Module = typeof Modules[keyof typeof Modules];
export type Permission = typeof Permissions[keyof typeof Permissions];

// 權限檢查輔助函數
export const hasPermission = (userPermissions: string[], requiredPermission: string): boolean => {
  // 如果使用者是管理員，擁有所有權限
  if (userPermissions.includes(Permissions.ADMIN)) {
    return true;
  }
  
  // 檢查是否有指定權限
  return userPermissions.includes(requiredPermission);
};

// 檢查多個權限（任一滿足）
export const hasAnyPermission = (userPermissions: string[], requiredPermissions: string[]): boolean => {
  return requiredPermissions.some(permission => hasPermission(userPermissions, permission));
};

// 檢查多個權限（全部滿足）
export const hasAllPermissions = (userPermissions: string[], requiredPermissions: string[]): boolean => {
  return requiredPermissions.every(permission => hasPermission(userPermissions, permission));
};

// 從模組和動作生成權限字串
export const generatePermission = (module: Module, action: PermissionAction): string => {
  const actionMap: Record<string, string> = {
    query: 'QUERY',
    add: 'ADD',
    edit: 'EDIT',
    delete: 'DELETE',
    export: 'EXPORT',
    print: 'PRINT',
    approve: 'APPROVE',
  };
  
  return `${module}_${actionMap[action]}`;
};
